// src/components/OrderEntry/utils/postal.js
// =============================================================================
// POSTAL CODE UTILITIES
// =============================================================================

/**
 * Normalize postal text for customer/address prefix lookup.
 * - letters + digits only
 * - uppercase
 * - strips spaces/punctuation
 * - capped to 10 chars
 */
export default function normalizePostal5(val) {
  return String(val ?? '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 10);
}

export function normalizeZipFieldValue(value, { internationalSale = false } = {}) {
  const raw = String(value ?? '').trim();

  if (internationalSale) {
    return raw
      .replace(/[^A-Z0-9]/gi, '')
      .toUpperCase()
      .slice(0, 6);
  }

  return raw.replace(/\D/g, '').slice(0, 5);
}

/**
 * Keep legacy US ZIP behavior (digits only, max 5) for freight/ETA flows.
 */
export function normalizeUsZip5(val) {
  return String(val ?? '')
    .trim()
    .replace(/\D/g, '')
    .slice(0, 5);
}
